import { render, staticRenderFns } from "./ReportSessionDetailVCall.vue?vue&type=template&id=8915cd34"
import script from "./ReportSessionDetailVCall.vue?vue&type=script&lang=js"
export * from "./ReportSessionDetailVCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports